import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Brand, CopyButton, Icon } from '@recargas-dominicanas/core/components';
import { WhatsappIcon } from '@recargas-dominicanas/core/icons';
import { useBusiness } from '@recargas-dominicanas/core/store';
import banreservas from '../../images/banreservas.png';
import popular from '../../images/popular.png';
import bhd from '../../images/bhd.png';
import { style } from './how-to-buy-balance.module.css';

export function HowToBuyBalance() {

  const businessStore = useBusiness();

  const bankAccounts = [
    { name: 'Banreservas', type: 'Cuenta corriente', number: '9607208524', image: banreservas },
    { name: 'Banco Popular', type: 'Cuenta corriente', number: '840900617', image: popular },
    { name: 'Banco BHD', type: 'Cuenta de ahorros', number: '36354790015', image: bhd }
  ];

  useEffect(() => {
    businessStore.fetch();
    const intervalId = setInterval(() => businessStore.fetch(), 2000);
    return () => clearInterval(intervalId);
  }, []);

  if (!businessStore.business?.customer || businessStore.business.customer.status !== 'new') {
    return <Navigate to='/' replace={true}/>;
  }

  return (
    <div className={style.container}>
      <header className={style.header}>
        <Brand/>
      </header>
      <div className={style.content}>
        <div className={style.iconContainer}>
          <Icon icon='account_balance' className={style.heroIcon} variant='round'/>
        </div>
        <h1 className={style.title}>Comprar balance</h1>
        <p className={style.intro}>
          Compra el balance que utilizaras para vender recargas para terminar de activar tu Cuenta. Puedes empezar desde <b>RD$500</b>.
        </p>
        <div className={style.reference}>
          <Icon icon='info' className={style.referenceIcon}/>
          <div className={style.referenceText}>
            <b>Tu ID de negocio: {businessStore.business.id}</b>
            <span>Inclúyelo en la referencia o concepto del depósito o transferencia.</span>
          </div>
        </div>
        <section className={style.bankSection}>
          <h2 className={style.bankTitle}>Cuentas bancarias</h2>
          <p className={style.bankOwner}>Todas las cuentas están a nombre de <b>Recargas Dominicanas Redomi E.I.R.L.</b></p>
          <ul className={style.bankList}>
            {bankAccounts.map(bank => (
              <li key={bank.name} className={style.bankAccount}>
                <img src={bank.image} className={style.bankLogo} alt=''/>
                <div className={style.bankDetails}>
                  <div className={style.bankHeading}>
                    <span className={style.bankName}>{bank.name}</span>
                    <span className={style.bankType}>{bank.type}</span>
                  </div>
                  <span className={style.bankNumber}>{bank.number}</span>
                </div>
                <CopyButton text={bank.number}/>
              </li>
            ))}
          </ul>
        </section>
        <div className={style.actions}>
          <a
            className={style.receiptButton}
            href='https://wa.me/18495071210'
            target='_blank'
            rel='noopener noreferrer'>
            <WhatsappIcon className={style.receiptIcon}/>
            Enviar comprobante
          </a>
          <a
            className={style.salesButton}
            href='https://wa.me/18495071210'
            target='_blank'
            rel='noopener noreferrer'>
            <Icon icon='support_agent' className={style.salesIcon}/>
            Hablar con ventas
          </a>
          <p className={style.salesNote}>
            Si necesitas ayuda para comprar balance o activar tu cuenta, ponte en contacto con nuestro equipo de ventas (849) 507-1210.
          </p>
        </div>
      </div>
    </div>
  );
}
